import { apiGateway } from "@/shared/apiGateway";

const getPlantsWithoutStatInspListing = (
  context,
  { filterCriteria, searchCriteria }
) => {
  var url = "api/statutoryInspections/plants-without-stat-insp";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.clientId !== "0") {
    url = url + "&clientId=" + filterCriteria.clientId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDPLANTSWITHOUTSTATINSP", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting plants without Stat. Insp."],
        { root: true }
      );
    });
};

const getStatInspListing = (context, { filterCriteria, searchCriteria }) => {
  var url = "api/statutoryInspections";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.clientId !== "0") {
    url = url + "&clientId=" + filterCriteria.clientId;
  }
  if (filterCriteria.statInspStatusId !== 0) {
    url = url + "&statInspStatus=" + filterCriteria.statInspStatusId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDSTATINSPS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Statutory Inspections"],
        {
          root: true
        }
      );
    });
};

const getStatInsp = (context, statInspId) => {
  return apiGateway
    .apiGatewayGET("api/statutoryInspections/" + statInspId)
    .then(data => {
      context.commit("STATINSP_SETSTATINSP", data);
      context.commit("STATINSP_UPDATESTATINSPITEMS", data.statInspItems);
    })
    .catch(error => {
      console.error(error);
      context.commit("STATINSP_SETSTATINSP", undefined);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Stat. Insp. - " + error.response.data],
        {
          root: true
        }
      );
    });
};

const getStatInspItemDetail = (context, statInspItemId) => {
  return apiGateway
    .apiGatewayGET(
      "api/statutoryInspections/get-stat-insp-item/" + statInspItemId
    )
    .then(data => {
      context.commit("STATINSP_SETSTATINSPITEM", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat. Insp. item"], {
        root: true
      });
    });
};

const createStatInspItemNote = (commit, body) => {
  body.noteType = 3;
  return apiGateway.apiGatewayPATCH(
    "api/statutoryInspections/update-stat-insp-item-notes",
    body
  );
};

const updateStatInspItemStatus = (commit, statInspItemStatus) => {
  statInspItemStatus.noteType = 3;
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/update-stat-insp-item-status/",
      statInspItemStatus
    )
    .then(data => {
      return data;
    });
};

const getPagedStatInspItems = (context, { filterCriteria, searchCriteria }) => {
  var url = "api/statutoryInspections/paged-stat-insp-items";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.clientId !== "0") {
    url = url + "&clientId=" + filterCriteria.clientId;
  }
  url = url + "&statInspItemStatus=" + filterCriteria.statInspItemStatusId;
  if (filterCriteria.statInspItemTypeId !== 0) {
    url = url + "&statInspItemType=" + filterCriteria.statInspItemTypeId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEPAGESSTATINSPITEMS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat Insp Items"], {
        root: true
      });
    });
};

const createStatInspItemQuote = (commit, form) => {
  form.noteType = 3;
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/create-stat-insp-item-quote",
      form
    )
    .then(data => {
      return data;
    });
};

export default {
  createStatInspItemNote,
  getStatInsp,
  getStatInspItemDetail,
  getStatInspListing,
  getPagedStatInspItems,
  getPlantsWithoutStatInspListing,
  updateStatInspItemStatus,
  createStatInspItemQuote
};
